import { Controller } from "@hotwired/stimulus"

// Client-facing view mode for the account-health dashboard. State lives in a global cookie
// (not per-account) so it persists as the user moves between accounts — the use case is
// presenting on a call and never accidentally showing internal labels. The server reads the
// cookie and renders data-client-view on the root for first paint; this controller syncs the
// switch UI from that, and on toggle rewrites the cookie + updates the DOM live.
export default class extends Controller {
  static targets = ["switch", "knob"]

  static COOKIE = "account_health_client_view"

  connect() {
    this.on = this.element.dataset.clientView === "true"
    this.apply()
  }

  toggle() {
    this.on = !this.on
    // Global (path=/), ~1 year, so it survives navigation and browser restarts.
    document.cookie = `${this.constructor.COOKIE}=${this.on}; path=/; max-age=31536000; SameSite=Lax`
    this.apply()
  }

  apply() {
    this.element.dataset.clientView = this.on ? "true" : "false"
    if (this.hasSwitchTarget) {
      this.switchTarget.setAttribute("aria-checked", this.on)
      this.switchTarget.classList.toggle("bg-sg-green", this.on)
      this.switchTarget.classList.toggle("bg-sg-gray-200", !this.on)
    }
    if (this.hasKnobTarget) {
      // Mutually exclusive so the two positions don't both apply and cancel out.
      this.knobTarget.classList.toggle("translate-x-4", this.on)
      this.knobTarget.classList.toggle("translate-x-0.5", !this.on)
    }
  }
}
